import { call, put, takeLatest } from 'redux-saga/effects'
import axios from 'axios'

import { BACKEND_URL } from 'config/constants'
import { getPagePath } from 'config/routes'

import {
  SECURITY__AUTH_CHECK,
  SECURITY__AUTH_LOGOUT,
  SECURITY__AUTH_TOKEN_EXPIRED,
  SECURITY__FAILED_AUTH,
  SECURITY__START_LOGIN,
  SECURITY__USER_AUTHENTICATED,
} from './reducer'

function* startLogin() {
  localStorage.removeItem('token')
  localStorage.removeItem('profile')
  window.location = `${BACKEND_URL}/auth/login`
  yield null
}

function* authLogout({ payload }) {
  localStorage.removeItem('token')
  localStorage.removeItem('profile')
  const { token } = payload

  window.location = `${BACKEND_URL}/auth/logout?token=${token}`
  yield null
}

function* authTokenExpired({ payload }) {
  localStorage.removeItem('token')
  localStorage.removeItem('profile')
  const { push } = payload

  yield push({ pathname: getPagePath('login') })
}

function* authCheck({ payload }) {
  const { search, push } = payload
  const params = new URLSearchParams(search)
  const token = params.get('access_token')

  localStorage.setItem('token', token)

  function fetchProfile() {
    return axios(`${BACKEND_URL}/user/profile`, {
      headers: { Authorization: `Bearer ${token}` },
    })
      .then(response => ({ response }))
      .catch(error => ({ error }))
  }

  if (params.has('error')) {
    yield push({ pathname: getPagePath('login'), search })

    return
  }

  const { response, error } = yield call(fetchProfile)

  if (response) {
    const { data: profile } = response

    localStorage.setItem('profile', JSON.stringify(profile))

    yield put({
      type: SECURITY__USER_AUTHENTICATED,
      payload: { token, profile, error: null },
    })
  } else {
    const { response: errorResponse } = error

    yield put({
      type: SECURITY__FAILED_AUTH,
      payload: { error: errorResponse },
    })
  }
}

function* SecuritySagas() {
  yield takeLatest(SECURITY__START_LOGIN, startLogin)
  yield takeLatest(SECURITY__AUTH_CHECK, authCheck)
  yield takeLatest(SECURITY__AUTH_TOKEN_EXPIRED, authTokenExpired)
  yield takeLatest(SECURITY__AUTH_LOGOUT, authLogout)
}

export default SecuritySagas
